export default "__VITE_ASSET__DuU8bVLG__"